import { Component, OnInit, Inject, ViewEncapsulation } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { ServerService } from "src/app/services/server.service";
import { ClipBoardService } from "src/app/services/clipboard.service";
@Component({
  selector: "app-create-campaign-task",
  templateUrl: "./create-campaign-task.component.html",
  styleUrls: ["./create-campaign-task.component.scss"],
})
export class CreateCampaignTaskComponent implements OnInit {
  authToken = localStorage.getItem("token");
  adminUser: any;
  selectedUser: any;
  task_description: any;
  task_type: any;
  task_subject: any;
  allTaskTypes: any;
  selectedType: any;
  btnStatus = false;
  constructor(
    private dialogRef: MatDialogRef<CreateCampaignTaskComponent>,
    private _serverService: ServerService,
    private clipBoardService: ClipBoardService,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}

  ngOnInit() {
    this.getAllTaskType();

    this.getAllVendorAdmin();
  }
  close() {
    this.dialogRef.close();
  }
  getAllVendorAdmin() {
    this._serverService
      .getallVendorAdminForCampaign(this.authToken)
      .subscribe((data) => {
        this.adminUser = data.data;
        // console.log(data.data)
      });
  }
  getAllTaskType() {
    this._serverService.getAllStatus(this.authToken).subscribe((data: any) => {
      //console.log(data)
      this.allTaskTypes = data.campaign_task_type;
      // console.log(this.allTaskTypes)
    });
  }
  create() {
    this.btnStatus = true
    let body = {
      subject: this.task_subject,
      task_type: this.selectedType,
      description: this.task_description,
      campaign_id: this.data,
      assigned_user_id: this.selectedUser,
    };
    this._serverService
      .createTaskInCampaign(body, this.authToken)
      .subscribe((data) => {
        this.clipBoardService.showMessgeInText(
          "Task Created Succesfully",
          "success-snackbar"
        );
        this.dialogRef.close(data);
        // console.log(data)
      },
      error => {
       console.error('Task Creation failed', error);
       this.btnStatus = false;
       // this.showComponentLoader = false;
     });
  }
  get isFormInvalid(): boolean {
    return (
      !this.selectedUser ||
      !this.task_description ||
      !this.selectedType ||
      !this.task_subject
    );
  }
  userType(item) {
    return item.org_admin && !item.role
      ? 'Vendor Admin'
      : !item.org_admin && !item.role
      ? 'Vendor Standard User'
      : item.role;
  }
}
